import React, { useState } from 'react';
import Button from '../../../components/Button';

function CancelPopup({ isOpen, onClose, onSubmit }) {
    const [reason, setReason] = useState('');

    const handleSubmit = () => {
        if (reason.trim()) {
            onSubmit(reason);
            setReason('');
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <h3>Motivo do Cancelamento</h3>
                <textarea
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Informe o motivo do cancelamento..."
                    style={styles.textarea}
                />
                <div className='w-100 text-right'>
                    <Button
                        label="Cancelar"
                        theme="danger"
                        onClick={onClose}
                    />
                    <Button
                        label='Salvar'
                        className={'ml-1'}
                        onClick={handleSubmit}
                        disabled={!reason.trim()} // Desabilita o botão se o campo estiver vazio
                    />
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        width: '405px',
    },
    textarea: {
        width: '95%',
        height: '80px',
        marginBottom: '10px',
        padding: '8px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        resize: 'none',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

export default CancelPopup;
